import { provideObjClass } from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"
import { ScrivitoAttributes } from "shared/types/ScrivitoAttributes"

export const SharedProjectPageObjClass = provideObjClass("SharedProjectPage", {
  attributes: {
    ...defaultPageAttributes,
    data: "datalocator",
    chatWidgets: "widgetlist",

    enableChat: "boolean",
    chatButtonText: "string",
    hideChatWhenNoOpportunity: "boolean"
  },
  extractTextAttributes: ["body"]
})
export type SharedProjectPageObj = InstanceType<
  typeof SharedProjectPageObjClass
>
export type SharedProjectPageObjAttributes =
  ScrivitoAttributes<SharedProjectPageObj>
